import gql from 'graphql-tag'

export const HAND_OVER_MODEL_FRAGMENT = gql`
  fragment HandOverModelFields on HandoverModel {
    arrival
    finish
    start
  }
`
